import { jsx as _jsx } from "react/jsx-runtime";
import Button from './Button';
const PrimaryButton = ({ destructive, className, ...props }) => {
    return (_jsx(Button, { "aria-label": "Primary button", className: `${className || ''} min-w-36 rounded-md px-5 py-3 font-bold text-white ${destructive
            ? 'bg-red-600 hover:bg-red-700 disabled:border-red-200 disabled:bg-red-200'
            : 'bg-blue-600 hover:bg-blue-700 disabled:border-blue-200 disabled:bg-blue-200'}`, ...props }));
};
export default PrimaryButton;
